import { render, staticRenderFns } from "./chaternewtypexbk.vue?vue&type=template&id=4f66984c&scoped=true"
import script from "./chaternewtypexbk.vue?vue&type=script&lang=js"
export * from "./chaternewtypexbk.vue?vue&type=script&lang=js"
import style0 from "./chaternewtypexbk.vue?vue&type=style&index=0&id=4f66984c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f66984c",
  null
  
)

export default component.exports